import Box from '@mui/material/Box';
import { Button, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery }
    from '@mui/material';
import { observer } from 'mobx-react-lite';
import CloseIcon from '@mui/icons-material/Close';
import { SubPartner, SubPartnersKobHoved } from '../../app/models/partners';
import { useStore } from '../../app/stores/store';
import { adminUserStyles } from '../admin/adminUsers/adminUserStyles';

interface Propsaaa {
    partnerData: SubPartnersKobHoved;
}
const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#B6DAFF',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
    })
};


const SubPartnerModal = ({ partnerData }: Propsaaa) => {

    const { modalStore } = useStore();
    const { closeModal } = modalStore;

    const matches = useMediaQuery('(min-width:900px)');

    const closeModalHandler = () => {

        closeModal();
    }

    if (!partnerData)
        return null;
    return (
        <Box sx={style(matches)}>
            <Typography variant='h6' textAlign='center'>{partnerData.customerName}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        {partnerData.subPartners.length > 0 &&
                            <Table>
                                <TableHead key={'tableKey'}>
                                    <TableRow>
                                        <TableCell align="left" sx={adminUserStyles.tableCellStyle}>Name</TableCell>
                                        <TableCell align="left" sx={adminUserStyles.tableCellStyle}>Role</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {partnerData.subPartners.map((p: SubPartner, index) =>
                                        <TableRow sx={{ bgcolor: '#478ac92e' }}
                                            key={index}
                                        >
                                            <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                                {p.subPartnerName}
                                            </TableCell>
                                            <TableCell align="left" sx={adminUserStyles.tableCellStyle}>
                                                {p.role}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        }
                    </TableContainer>
                    <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        pt={2}
                    >
                        <Button size={matches ? "medium" : "small"} variant="contained" onClick={closeModalHandler}
                            startIcon={<CloseIcon />}>Close</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}
export default observer(SubPartnerModal);